<template>
  <v-app>
    <UatAdminBlockedScreen v-if="isUatAdmin" />
    <component v-else :is="layout">
      <router-view />
    </component>
  </v-app>
</template>

<script>
import DefaultLayout from '@/layout/DefaultLayout'
import NoLayout from '@/layout/NoLayout'
import AppLayout from '@/app/layouts/AppLayout.vue'
import UatAdminBlockedScreen from '@/components/common/UatAdminBlockedScreen.vue'
import { checkVersion } from '@/version'
import {
  isUatAdminEnvironment,
  performImmediateUatAdminLogout
} from '@/utils/enforceUatAdminDeprecation'

export default {
  name: 'App',
  components: {
    DefaultLayout,
    NoLayout,
    AppLayout,
    UatAdminBlockedScreen
  },
  computed: {
    isUatAdmin() {
      return isUatAdminEnvironment()
    },
    layout() {
      const layoutName = this.$route.meta.layout || 'DefaultLayout'
      return layoutName
    }
  },
  created() {
    if (this.isUatAdmin) {
      performImmediateUatAdminLogout()
    }
  },
  mounted() {
    if (this.isUatAdmin) {
      performImmediateUatAdminLogout()
    } else {
      checkVersion()
    }
  }
}
</script>

